/* eslint-disable arrow-body-style, max-len */
import { find, sumBy } from 'lodash';
import api from '@/services/api';
import { updateMarketContracts, updateMySharesMarket } from '@/utils/notifications';
import { marketUserGainLoss } from '@/utils/helpers';
import ls from '@/helpers/localStorage';

import {
  ORDERS,
  TIMESPANS,
  AVAILABLE_TIMESPANS,
  DEFAULT_TIMESPANS,
  ORDERS_WITH_TIMESPAN_FILTER } from './filters_consts';


const KEY_SHOULD_SHOW_TIMESPAN = 'should-show-timespan';
const KEY_SELECTED_ORDER = 'selected-order';
const KEY_SELECTED_TIMESPAN = 'selected-timespan';

const DEFAULT_NOTIFICATIONS = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true,
};


export default {
  namespaced: true,
  state: {
    markReadIsBeingCalled: false,
    marketsToggle: null,
    myShares: null,
    mySharesReady: false,
    notifications: Object.create(DEFAULT_NOTIFICATIONS),
    notificationsToggle: false,
    orders: ORDERS,
    timespans: TIMESPANS,
    selectedOrder: ls.get(KEY_SELECTED_ORDER, ORDERS[0]),
    selectedTimespan: ls.get(KEY_SELECTED_TIMESPAN, AVAILABLE_TIMESPANS.ALL),
    shouldShowTimespanFilter: ls.get(KEY_SHOULD_SHOW_TIMESPAN, true),
  },
  getters: {
    mySharesCount: (state) => {
      return state.myShares ? state.myShares.markets.length : 0;
    },
    mySharesTotalGainLoss: (state) => {
      if (state.myShares && state.myShares.markets) {
        return sumBy(state.myShares.markets, marketUserGainLoss);
      }
      return 0;
    },
  },
  mutations: {
    setMarketsToggle(state, flag) {
      state.marketsToggle = flag;
    },
    setMyShares(state, payload) {
      state.myShares = payload;
      state.mySharesReady = true;
    },
    setSummaryChartData(state, payload) {
      state.summaryChart = payload;
    },
    updateNotifications(state, payload) {
      const sourceNotifications = payload.data.notificationItems || [];
      sourceNotifications.forEach((el) => {
        el.contentJson = (typeof el.contentJson === 'string') ? JSON.parse(el.contentJson) : el.contentJson;
      });
      const data =
        state.notifications.data.concat(sourceNotifications);
      const page = payload.data.page;
      const totalCount = payload.data.totalItems;
      const canLoadMore = totalCount > data.length;

      state.notifications = {
        ...state.notifications,
        data,
        page,
        totalCount,
        canLoadMore,
      };
    },
    resetNotifications(state) {
      state.notifications = Object.create(DEFAULT_NOTIFICATIONS);
    },
    updateMySharesFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = {
          ...state.myShares,
          markets: state.myShares.markets.map(market => updateMySharesMarket(market, data)),
        };
      }
    },
    updateMySharesContractFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = {
          ...state.myShares,
          markets: state.myShares.markets.map(market => updateMarketContracts(market, data)),
        };
      }
    },
    toggleNotifications(state) {
      state.notificationsToggle = !state.notificationsToggle;
    },
    selectOrder(state, sort) {
      const selectedOrder = find(state.orders, { sort });
      const selectedTimespan = DEFAULT_TIMESPANS[sort] || AVAILABLE_TIMESPANS.EMPTY;
      const shouldShowTimespan = ORDERS_WITH_TIMESPAN_FILTER
        .indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      ls.set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      ls.set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      ls.set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan(state, parameter) {
      const selectedTimespan = find(state.timespans, { parameter });
      state.selectedTimespan = selectedTimespan;
      ls.set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    setMarkReadBeingCalled(state, value) {
      state.markReadIsBeingCalled = value;
    },
  },
  actions: {
    getMyShares({ state, commit }) {
      return api.profile.getMyShares(state.selectedOrder.sort, state.selectedTimespan.parameter)
        .then((response) => {
          commit('setMyShares', response.data);
          return response.data;
        });
    },
    resetNotifications({ commit }) {
      commit('resetNotifications');
    },
    getNotifications({ state, commit }) {
      if (state.notifications.canLoadMore) {
        const page = state.notifications.page + 1;
        return api.profile.getNotifications(page)
          .then((response) => {
            commit('updateNotifications', {
              page,
              data: response.data,
            });
            return response.data;
          });
      }
      return Promise.resolve(null);
    },
    markNotificationsAsRead({ commit, state }) {
      if (state.markReadIsBeingCalled) return Promise.resolve({});

      commit('setMarkReadBeingCalled', true);
      return api.profile.putNotifications()
        .then((response) => {
          commit('setMarkReadBeingCalled', false);
          return response.data;
        })
        .catch((error) => {
          commit('setMarkReadBeingCalled', false);
          throw error;
        });
    },
    updateMySharesFromNotification({ commit }, payload) {
      commit('updateMySharesFromNotification', payload);
    },
    updateMySharesContractFromNotification({ commit }, payload) {
      commit('updateMySharesContractFromNotification', payload);
    },
    selectOrder({ commit, dispatch }, sort) {
      commit('selectOrder', sort);
      return dispatch('getMyShares');
    },
    selectTimespan({ state, dispatch, commit }, timespan) {
      commit('selectTimespan', timespan);
      return dispatch('getMyShares');
    },
    toggleNotifications({ commit }) {
      commit('toggleNotifications');
    },
    setMarketsToggle({ commit }, flag) {
      commit('setMarketsToggle', flag);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js